

<div id="myappviewscrollupdate"></div>
<p-card  [style]="{'margin-bottom':'20px'}">
    <p-header>
    <h2 style="font-weight: 700;font-size: 1.5em;font-family:
     Open Sans,Helvetica Neue,sans-serif;color: #666;box-sizing: border-box;margin-bottom: .5em;margin-left: 6px;margin-top: 6px;">
     Update Application

     <span *ngIf="pathInfo=='production'" class="badge badge-pill badge-primary">{{pathInfo}}</span>
               
     <span *ngIf="pathInfo=='sandbox'" class="badge badge-pill badge-secondary">{{pathInfo}}</span>
    </h2>
    </p-header>
   
    <div class="ui-fluid">
        <div class="p-field " class="break-msg">
            <p-messages key="updateappKey" class="break-msg" class="aetna-msg" [(value)] ="updateMsgs" [closable]="false"></p-messages>
          </div> 
            <div class="p-field">
                 <label for="appNAme">Application Name</label>
                 <div style="font-weight: bold;">
                  <u> {{appName}}</u>  
                 </div>
            </div>
            <div class="p-field" *ngIf="appSys=='apigee'">
                <br>
                        <label for="chplePdNumL">CHPL Product Number <span style="color: red; font-weight: bold;">*</span></label>
                        <input type="text" class="form-control" #chplePdNumL='ngModel' name="chplePdNumL" [(ngModel)]="chplProductId"   (blur)="chplProductId= chplProductId.trim();" required>
                        
                        <div *ngIf="chplePdNumL.touched && chplePdNumL.invalid">
                          <div *ngIf="chplePdNumL.errors?.required" class="text-danger">* Please enter CHPL Product Number</div> 
                         
                        </div> 
            </div>
            <div class="p-field" *ngIf="appSys=='apigee'">
                <br>
                <label for="chplePdNameL">Product Name
                    <span style="color: red; font-weight: bold;">*</span>
                  </label>
                   <input type="text" class="form-control" #chplePdNameL='ngModel' name="chplePdNameL" [(ngModel)]="chplProductName" (blur)="chplProductName= chplProductName.trim();"  required>
                   <div *ngIf="chplePdNameL.touched">
                    <div *ngIf="chplePdNameL.errors?.required" class="text-danger">* Please enter CHPL Product Name</div> 
                   
                  </div>
            </div>
           
          
           <div class="p-field" *ngIf="appSys=='apigee'">
                <br>
                <label for="jwks">JWKS URL
                    <span style="color: red; font-weight: bold;">*</span>
                </label>
                <input #jwks='ngModel' minlength="1" maxlength="100"   required  pInputText type="text" [(ngModel)]="jwksURL" placeholder="Required"> 
                <div *ngIf="jwks.touched  && jwks.invalid">
                    <div *ngIf="jwks.errors?.required" class="text-danger">* Please enter JWKS URL</div> 
                  
                  </div>  
          
            </div>
            <div class="p-field" *ngIf="appSys=='apigee'">
                <br>
                <label for="kidL">Key ID
                    <span style="color: red; font-weight: bold;">*</span>
                </label>
                <input #kidL='ngModel'    required  pInputText type="text" [(ngModel)]="kid" placeholder="Required"> 
                <div *ngIf="kidL.touched && kidL.invalid">
                    <div *ngIf="kidL.errors?.required" class="text-danger">* Please enter Key ID</div> 
                  
                  </div>  
            
            </div>
            <div class="p-field">
                <br>
                <label for="callb">Callback URL
                    <span style="color: red; font-weight: bold;">*</span>
                </label>
                <input #callb='ngModel' minlength="1" maxlength="100"   required  pInputText type="text" [(ngModel)]="appCallBackUrl" placeholder="Required"> 
               
                <div *ngIf="callb.touched && callb.invalid">
                    <div *ngIf="callb.errors?.required" class="text-danger">* Please enter Callback URL</div> 
                  
                  </div>  
            </div>
			
            <div class="p-field">
                <br>
				<div class="container-fluid" style="width:100%;background-color:white;" >
                    <div class="row" >
                        <div class="col-md-3">
                            <br>
                            <button pButton type="button" icon="pi pi-pencil"  #updateappid (click)="updateApp()"  label="Update"   class="aetna-button ui-button-raised ui-button-rounded"></button>
                        </div>
                        <div class="col-md-3">
                            <br>
                            <button pButton type="button" icon="pi pi-trash" #deleteupdateappid (click)="deleteConfirmation()" label="Delete"   class="aetna-button ui-button-raised ui-button-rounded"></button>
                         </div>
                         <div class="col-md-3">
                            <br>
                            
                            <div *ngIf="appSys!='apigee'">
                                <button pButton type="button" icon="pi pi-key" #resetclientsecretid (click)="clientsecretResetConfirmation()" label="Client Secret Reset"   class="aetna-button ui-button-raised ui-button-rounded"></button>
                            </div>
                            <div *ngIf="appSys=='apigee'">
                                <button pButton type="button" icon="pi pi-key" #resetclientsecretid (click)="clientsecretResetConfirmation()" label="Client Credentials Reset"   class="aetna-button ui-button-raised ui-button-rounded"></button>
                            </div>
                           
                         </div> 
                         <div class="col-md-3">
                            <br>
                            <button pButton type="button" icon="pi pi-clone" #verifyclientsecretid (click)="getClientSecret()" label="Verify Client Secret"   class="aetna-button ui-button-raised ui-button-rounded"></button>
                         </div> 
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="loadAppRequest" >
            <p-progressBar  class="customProgress" mode="indeterminate" [style]="{'height': '6px'}"></p-progressBar>
            <br>
        </div>
</p-card>

<p-dialog  header="Delete App"  [modal]="true" [closable]="false" [(visible)]="confirmationPopup" [style]="{width: '50vw'}" [baseZIndex]="10000">
  
   <label class="font-weight-bold">Are you sure to delete this App {{appName}}.</label>
<p-footer>
    <button type="button" pButton icon="pi pi-check" (click)="deleteApp()" label="Yes"class="aetna-button ui-button-raised ui-button-rounded" ></button>
    <button type="button"  pButton icon="pi pi-times" (click)="deletecancelConfirmation()" label="No" class="aetna-button ui-button-raised ui-button-rounded"></button>
</p-footer>
</p-dialog>
<p-dialog  header="Client Secret Reset" [modal]="true" [closable]="false" [(visible)]="clientResetPopup" [style]="{width: '50vw'}" [baseZIndex]="10000">
  
    <label *ngIf="apigeeMsg" class="font-weight-bold"> Are you sure to reset the client id & client secret? </label>
    <label  *ngIf="!apigeeMsg" class="font-weight-bold"> Are you sure to reset the client secret? </label>

 <p-footer>
     <button type="button" pButton icon="pi pi-check" (click)="resetClientSecret()" label="Yes"class="aetna-button ui-button-raised ui-button-rounded" ></button>
     <button type="button"  pButton icon="pi pi-times" (click)="clientsecretResetcancelConfirmation()" label="No" class="aetna-button ui-button-raised ui-button-rounded"></button>
 </p-footer>
 </p-dialog>

<p-dialog header="Verify client Secret" [modal]="true" [closable]="false" [(visible)]="clientsecretPopup" [style]="{width: '50vw'}" [baseZIndex]="10000">
    <div class="ui-fluid">
    <div class="p-field">
    <label for="Clientsecret">Client Secret</label> 
    <input id="clientsecret"  pInputText type="text" [(ngModel)]="clientsecret" placeholder="Required" minlength="1" maxlength="200" required> 
    </div>
    </div>
 <p-footer>
     <button type="button" pButton icon="pi pi-check" (click)="verifyClientSecret()" label="Yes"class="aetna-button ui-button-raised ui-button-rounded" ></button>
     <button type="button"  pButton icon="pi pi-times" (click)="getClientSecretcancelConfirmation()" label="No" class="aetna-button ui-button-raised ui-button-rounded"></button>
 </p-footer>
 </p-dialog>